import { z } from 'zod';
/** HST treatment per Q10. Operator MUST explicitly choose on every
 *  rate-card create — there is no default. Wrong default would create
 *  tax misclassification + CRA grief. */
export const HstTreatmentSchema = z.enum(['TAXABLE', 'EXEMPT', 'ZERO_RATED']);
/** Which side of a shift's rate a modifier touches. */
export const RateModifierApplyToSchema = z.enum(['PAY', 'BILL', 'BOTH']);
/** Modifier composition formula. Locked order per 8A (2026-06-03):
 *  rate engine applies ALL multiply-formula modifiers first, then ALL
 *  add-formula modifiers on the result. See `RateService.resolveRate`
 *  in 8b for the canonical implementation + tests. */
export const RateModifierFormulaSchema = z.enum(['ADD', 'MULTIPLY']);
/** Time-of-day buckets used by FacilityBillRateOverride to scope an
 *  override to a specific window (or null = all day). The engine
 *  derives the bucket from a shift's local start time. */
export const ShiftTimeBucketSchema = z.enum(['DAY', 'EVENING', 'NIGHT']);
/** Setting in which a shift takes place. Kept as string (not enum) on
 *  the database side because the set is small + extensible without a
 *  Postgres-enum migration; Zod still validates the API surface. */
export const ShiftSettingSchema = z.enum(['LTC', 'HOMECARE']);
//# sourceMappingURL=enums.schema.js.map